import { ZCorrectionCartLineItem } from '@getjust/gateway/src/platform/prestashop/types';
import { atom } from 'jotai';
import { z } from 'zod';

export type CorrectionAtom = z.infer<typeof ZCorrectionCartLineItem>;

export const correctionsAtom = atom<CorrectionAtom[] | null>(null);
